export default __webpack_public_path__ + "static/media/collab.e78ea18b.png";